import React from "react";

const Explore = () => {
  return (
    <section className="md:py-14">
      <div className="container mx-auto md:px-20 px-4">
        <img src="././Bridaloutfit.webp" alt="" />
      </div>
    </section>
  );
};

export default Explore;
